import { useAppSelector } from "@/config/store";
import { IEdoChapter } from "@/shared/model/edo-chapter.model";
import { IEdoUnit } from "@/shared/model/edo-unit.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { Dialog, DialogContent, DialogHeader, DialogTitle, IconButton } from "@/components/ui";
import { X } from "lucide-react";
import "moment/locale/it";
import Units from "./Units";

export interface EditChapterUnitsProps {
  chapter?: IEdoChapter;
  open: boolean;
  handleClose: (updated: boolean) => void;
  handleOpenViewUnitDialog: (unit: IEdoUnit) => void;
  handleOpenEditUnitDialog: (unit: IEdoUnit | null) => void;
  handleOpenDeleteUnitDialog: (unit: IEdoUnit) => void;
}

export const EditChapterUnits = (props: EditChapterUnitsProps) => {
  const { updateSuccess } = useAppSelector<EntityState<IEdoChapter>>(
    (state) => state.edoChapter
  );

  const {
    chapter,
    open,
    handleClose,
    handleOpenViewUnitDialog,
    handleOpenEditUnitDialog,
    handleOpenDeleteUnitDialog,
  } = props;

  const handleCloseDialog = (updated: boolean) => {
    handleClose(updated);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleCloseDialog(true)}>
      <DialogContent
        showClose={false}
        className="flex max-h-[90vh] w-full max-w-2xl flex-col gap-0 overflow-hidden p-0 sm:max-h-[85vh]"
      >
        <DialogHeader className="shrink-0 flex-row items-center justify-between gap-4 border-b border-[var(--color-mockup-border)] px-6 py-4">
          <DialogTitle>Aggiungi unità al capitolo</DialogTitle>
          <IconButton
            onClick={() => handleCloseDialog(true)}
            aria-label="Chiudi"
          >
            <X className="h-4 w-4" />
          </IconButton>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-5">
          <Units
            chapter={chapter}
            handleOpenViewUnitDialog={handleOpenViewUnitDialog}
            handleOpenEditUnitDialog={handleOpenEditUnitDialog}
            handleOpenDeleteUnitDialog={handleOpenDeleteUnitDialog}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
